module.exports = __webpack_public_path__ + "img/bear.97b4875d.png";